export const formatNumberIn2Digits = (
  timeFragment: number | undefined
): string => {
  if (!timeFragment || timeFragment < 0) {
    return '00'
  }
  return timeFragment.toString().padStart(2, '0')
}
